import { createFileRoute } from '@tanstack/react-router';

import {
  AuctionQuestionsPage,
  questionListParams,
  questionListQueryOptions,
  questionListSearchSchema,
} from '@/features/auctions';

export const Route = createFileRoute('/_authed/_active/s/$storeId/auctions/questions')({
  staticData: { crumb: 'auctions:nav.questions' },
  validateSearch: questionListSearchSchema,
  loaderDeps: ({ search }) => search,
  loader: async ({ context, params, deps, cause }) => {
    const prefetch = context.queryClient
      .query({
        ...questionListQueryOptions(params.storeId, questionListParams(deps)),
        staleTime: 'static',
      })
      .catch(() => undefined);
    if (cause !== 'stay') await prefetch;
  },
  component: AuctionQuestionsPage,
});
